<template>
  <!-- 签约产品 -->
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form :inline="true" class="demo-form-inline">
          <div class="cg">
            <el-form-item label="角色名称：">
              <el-input v-model="listQuery.roleName" style="width: 200px" placeholder="请输入角色名称"
                        clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">搜索</el-button>
            </el-form-item>
          </div>
        </el-form>
        <el-table
          :header-cell-style="{ height: '40px' ,fontSize:'18px',color:'black',fontweight:400,background: '#fafafa'}"
          :header-row-style="{text: 'center'}"
          v-loading="listLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          :data="tableData"
          border style="width: 100%;margin-top: 50px;"
          :highlight-current-row="true">
          <el-table-column
            prop="poName"
            label="角色名称"
            align="center"
            width="180">
          </el-table-column>
          <el-table-column
            prop="poRemarks"
            header-align="center"
            align="left"
            label="备注">
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="updateTime"
            align="center"
            label="修改时间">
          </el-table-column>
          <el-table-column label="操作" width="180px" header-align="center">
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-edit" @click="editAuth(scope.row.poId)">权限编辑</el-button>
<!--                <el-button type="text" icon="el-icon-delete">删除</el-button>-->
              </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";

export default {
  data() {
    return {
      listQuery: {
        roleName: '',
      },
      listLoading: false, //加载样式
      tableData: [],
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
   
  },
}

</script>
<style scoped>
.demo-form-inline {
  height: 35px;
  display: flex;
}

.cg {
  /* flex: 1; */
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/ContractProduct.vue